// Bottom strip showing the active keymap's headline shortcuts. Every binding
// listed here is wired (App-level or screen-level) — the keymap files are kept
// truthful, so no muted "later phase" styling is needed. Hidden on touch-first
// devices (no physical keyboard → the strip is dead weight).

import { useShortcutRegistry } from '@/shortcuts/registry';
import { KbdChip } from '@/components/primitives/KbdChip';

export function KeymapHintFooter() {
  const keymap = useShortcutRegistry((s) => s.getKeymap());
  const mode = useShortcutRegistry((s) => s.mode);
  const visible = keymap.filter((b) => b.showInFooter !== false);

  return (
    <footer className="fixed bottom-0 inset-x-0 z-10 border-t border-mist bg-snow/90 backdrop-blur [@media(pointer:coarse)]:hidden">
      <div className="mx-auto flex max-w-[1280px] items-center gap-x-5 gap-y-1 overflow-x-auto px-6 py-2 text-caption text-slate">
        {visible.slice(0, 12).map((b) => (
          <span key={b.id} className="flex shrink-0 items-center gap-1.5">
            {b.combos.slice(0, 1).map((c) => (
              <KbdChip key={c}>{prettyCombo(c)}</KbdChip>
            ))}
            <span>{b.label}</span>
          </span>
        ))}
        <span className="ml-auto shrink-0 text-micro uppercase tracking-[0.12em] text-cool">
          {mode === 'tally' ? 'Classic' : 'Modern'} shortcuts
        </span>
      </div>
    </footer>
  );
}

function prettyCombo(combo: string): string {
  return combo
    .split('+')
    .map((p) => {
      if (p === 'ctrl') return 'Ctrl';
      if (p === 'alt') return 'Alt';
      if (p === 'shift') return 'Shift';
      if (p === 'meta') return '⌘';
      if (p === 'escape') return 'Esc';
      if (/^f\d+$/.test(p)) return p.toUpperCase();
      return p.length === 1 ? p.toUpperCase() : p[0].toUpperCase() + p.slice(1);
    })
    .join(' ');
}
